import angular from 'angular';

import Home from './home/home';
import Feasibility from './feasibility/feasibility';
import Blank from './blank/blank';
import Nest from './nest/nest';
import Report from './report/report';

import './components.styl';

let componentModule = angular.module('app.components', [
  Home,
  Feasibility,
  Blank,
  Nest,
  Report
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js